import { createMuiTheme } from '@material-ui/core/styles';
import themeConfig from './theme-config';

export default createMuiTheme(themeConfig);



// WEBPACK FOOTER //
// ./src/theme-default.js